import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable.jsx";
import { Select, Spin } from "antd";

import ApplyLeave from "./ApplyLeave.jsx";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_EMP_LEAVES,
} from "../RollCallConfig/RollCallConfig.js";
import { Tooltip as AntdToolTip } from "antd";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../core/common/footer/commonFooter.jsx";
import FallBackMessage from "../RollCallConfig/FallBackMessage.jsx";

const Leaves = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

  const [leaves, setLeaves] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const navigate = useNavigate();
  const [showAdd, setShowAdd] = useState(false);

  const statuses = ["All", "Pending", "Approved", "Rejected"];

  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;
    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];

    if (!perms) {
      navigate(`/${userData?.DefaultPath}`);
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);
  const regId = userData?.RegId;

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);
  console.log(leaves);

  // useEffect(() => {
  //   setloading(true);

  //   if (tokenData && superIdData) {
  //     fetch(
  //       `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_EMP_LEAVES}?superid=${superIdData}&regid=${regId}&year=${selectedYear}`,
  //       {
  //         method: "GET",
  //         headers: { Authorization: `Bearer ${tokenData}` },
  //       },
  //     )
  //       .then((response) => {
  //         console.log(response);
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         return response.json();
  //       })
  //       .then((data) => {
  //         if (data && data.status) {
  //           setLeaves(data.ResultData || []);
  //         } else {
  //           console.error("Invalid data format:", data);
  //           setLeaves([]);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //       })
  //       .finally(() => {
  //         setloading(false);
  //       });
  //   }
  // }, [superIdData, tokenData, selectedYear]);

  const handleLeavesView = async () => {
    try {
      setloading(true);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_EMP_LEAVES}?superid=${superIdData}&regid=${regId}&year=${selectedYear}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.status) {
        setLeaves(data.ResultData || []);
      } else {
        console.error("Invalid data format:", data);
        setLeaves([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      handleLeavesView();
    }
  }, [superIdData, tokenData, selectedYear]);

  const columns = [
    {
      title: "Start Date",
      dataIndex: "StartDt",
      sorter: (a, b) => new Date(a.StartDt) - new Date(b.StartDt),
      render: (text) => {
        const date = new Date(text);
        const formattedDate = `${String(date.getDate()).padStart(
          2,
          "0",
        )}-${String(date.getMonth() + 1).padStart(
          2,
          "0",
        )}-${date.getFullYear()}`;
        return formattedDate;
      },
    },
    {
      title: "End Date",
      dataIndex: "EndDt",
      sorter: (a, b) => new Date(a.EndDt) - new Date(b.EndDt),
      render: (text) => {
        const date = new Date(text);
        const formattedDate = `${String(date.getDate()).padStart(
          2,
          "0",
        )}-${String(date.getMonth() + 1).padStart(
          2,
          "0",
        )}-${date.getFullYear()}`;
        return formattedDate;
      },
    },
    {
      title: "Type",
      dataIndex: "LvCode",
      sorter: (a, b) => a.LvCode.length - b.LvCode.length,
      render: (text) => {
        const badgeMap = {
          CT: { color: "primary", label: "Casual" },
          PL: { color: "success", label: "Personal" },
          SL: { color: "danger", label: "Sick" },
          OD: { color: "warning", label: "On Duty" },
          WO: { color: "info", label: "Week Off" },
          OL: { color: "secondary", label: "Optional" },
          CO: { color: "dark", label: "Comp Off" },
          EL: { color: "primary", label: "Earned" },
          HL: { color: "light", label: "Holiday" },
        };

        const badge = badgeMap[text] || { color: "dark", label: text };

        return <span className={`badge bg-${badge.color}`}>{badge.label}</span>;
      },
    },
    {
      title: "Count",
      dataIndex: "LeaveCount",
      sorter: (a, b) => a.LeaveCount.length - b.LeaveCount.length,
    },

    {
      title: "Reason",
      dataIndex: "reason",
      sorter: (a, b) => a.reason.length - b.reason.length,
      render: (text) =>
        text ? (
          <AntdToolTip title={text}>
            {text.length > 15 ? `${text.slice(0, 15)}...` : text}
          </AntdToolTip>
        ) : (
          "-"
        ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        let badgeClass = "";
        let label = "";

        if (status === 1) {
          badgeClass = "badge-warning";
          label = "Pending";
        } else if (status === 2) {
          badgeClass = "badge-success";
          label = "Approved";
        } else if (status === 3) {
          badgeClass = "badge-danger";
          label = "Rejected";
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {label}
          </span>
        );
      },
      sorter: (a, b) => a.Status - b.Status,
    },
    {
      title: "Comments",
      dataIndex: "Comments",
      sorter: (a, b) => a.Comments.length - b.Comments.length,
      render: (text) =>
        text ? (
          <AntdToolTip title={text}>
            {text.length > 15 ? `${text.slice(0, 15)}...` : text}
          </AntdToolTip>
        ) : (
          "-"
        ),
    },
  ];

  const generatePDF = () => {
    if (leaves && leaves.length === 0) {
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const getLeaveTypeLabel = (code) => {
      const badgeMap = {
        CT: "Casual",
        PL: "Personal",
        SL: "Sick",
        OD: "On Duty",
        WO: "Week Off",
        OL: "Optional",
        CO: "Comp Off",
        EL: "Earned",
        HL: "Holiday",
      };
      return badgeMap[code] || code || "N/A";
    };

    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return "Pending";
        case 2:
          return "Approved";
        case 3:
          return "Rejected";
        default:
          return "N/A";
      }
    };

    const doc = new jsPDF();
    doc.text("Leaves Report", 14, 10);

    const tableColumn = [
      "Start Date",
      "End Date",
      "Leave Type",
      "Count",
      "Reason",
      "Status",
    ];

    const tableRows = leaves.map((item) => [
      formatDate(item.StartDt),
      formatDate(item.EndDt),
      getLeaveTypeLabel(item.LvCode),
      item.LeaveCount ?? "N/A",
      item.Total_Hours || item.Reason || "N/A",
      getStatusLabel(item.status),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Leaves_Report.pdf");
  };

  const handleDownloadExcel = () => {
    if (leaves && leaves.length === 0) {
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const getLeaveTypeLabel = (code) => {
      const badgeMap = {
        CT: "Casual",
        PL: "Personal",
        SL: "Sick",
        OD: "On Duty",
        WO: "Week Off",
        OL: "Optional",
        CO: "Comp Off",
        EL: "Earned",
        HL: "Holiday",
      };
      return badgeMap[code] || code || "N/A";
    };

    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return "Pending";
        case 2:
          return "Approved";
        case 3:
          return "Rejected";
        default:
          return "N/A";
      }
    };

    const wsData = leaves.map((item, index) => ({
      "S.No": index + 1,
      "Start Date": formatDate(item.StartDt),
      "End Date": formatDate(item.EndDt),
      "Leave Type": getLeaveTypeLabel(item.LvCode),
      Count: item.LeaveCount ?? "N/A",
      Reason: item.Total_Hours || item.Reason || "N/A",
      Status: getStatusLabel(item.status),
      Comments: item.Comments || "N/A",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Leaves Report");
    XLSX.writeFile(wb, "Leaves_Report.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={`/${userData?.DefaultPath}`}>
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Leaves
                    </h4>
                  </ol>
                </nav>
                <h6>Your Leaves At Glance</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li onClick={() => window.location.reload()}>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderRefreshTooltip}
                    >
                      <Link data-bs-toggle="tooltip" data-bs-placement="top">
                        <RotateCcw />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              {perm?.Write && (
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "></i>
                </Link>
              )}
            </ul>
            {/* <div className="page-btn mb-3"></div> */}
          </div>
          {/* /product list */}
          {perm?.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-2">
                    <Select
                      value={selectedYear}
                      style={{ width: 100 }}
                      onChange={(value) => setSelectedYear(value)}
                    >
                      {years.map((year) => (
                        <Select.Option key={year} value={year}>
                          {year}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  <div className="me-2 d-none">
                    <Select defaultValue="All" style={{ width: 120 }}>
                      {statuses.map((status) => (
                        <Select.Option key={status} value={status}>
                          {status}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  <div>
                    <button
                      className="btn btn-primary d-none"
                      onClick={() => console.log(status, currentYear)}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : leaves.length > 0 ? (
                    <Table columns={columns} dataSource={leaves} />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <FallBackMessage />
          )}
          {/* /product list */}
        </div>

        <CommonFooter />
      </div>
      <ApplyLeave
        isOpen={showAdd}
        handleLeavesView={handleLeavesView}
        onClose={() => setShowAdd(false)}
      />
    </div>
  );
};

export default Leaves;
